import { ReactNode } from "react";

interface Props {
  nodes: {
    svg: ReactNode;
    label: string | ReactNode;
  }[];
}
const BlogInfo: React.FC<Props> = ({ nodes }) => {
  return (
    <div className="info">
      {nodes.map((node, key) => (
        <div key={key} className="one-info">
          {node.svg}
          {node.label}
        </div>
      ))}
    </div>
  );
};

export default BlogInfo;
